<template>
  <div class="input-select d-block" v-on-clickaway="closeSelect"  @focus="openListOnFocus" @click="openListOnClick">
    <label
      v-if="label"
      @click="closeSelect"
      style="position: relative;">
      {{ $t(label) }}
      <span v-if="rules.required" class="warning-color">*</span>

      <!-- Info icon sa tooltip-om -->
      <span
        v-if="hint"
        class="hint-tooltip-wrapper"
        style="position: relative; display: inline-block; margin-left: 10px; vertical-align: text-top;">
    <Icon
      class="icon hint-icon"
      name="info"
      size="14"
      style="cursor: help; color: #999; position: relative; top: 3px;"
      @mouseenter.native="showTooltip = true"
      @mouseleave.native="showTooltip = false"/>

    <span
      v-show="showTooltip"
      class="hint-tooltip"
      style="position: absolute; bottom: calc(100% + 10px); left: 50%; transform: translateX(-50%);
             background: #333; color: #fff; padding: 8px 12px; border-radius: 4px;
             white-space: nowrap; font-size: 12px; z-index: 1000;
             box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
      {{ $t(hint) }}
      <!-- Strelica -->
      <span style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%);
                   width: 0; height: 0; border-left: 6px solid transparent;
                   border-right: 6px solid transparent; border-top: 6px solid #333;"></span>
    </span>
  </span>
    </label>
    <div
      :class="{required: shouldShowError, disabled : disabled}"
      @click.stop="openListOnClick"
      class="input-like"
      :tabindex="tabIndex"
      @focus.stop="openListOnFocus">
      <span v-if="cmpTextValue === ''"></span>
      <span v-if="cmpTextValue !== '' && !isShortened" class="cut-text">{{ cmpTextValue }}</span>
      <span v-if="cmpTextValue !== '' && isShortened">
        <CountryFlag :country="cmpTextValue" size='small' /> {{ cmpTextValue }}
      </span>
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <span v-if="shouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
    <div v-show="isListOpened" class="options-list country-options-list">
      <input
        ref="searchField"
        class="search"
        v-model="search"
        @keydown="searchIt"
        @click.stop
        :placeholder="$t('Search...')" />
      <hr v-if="multiSelect" />
      <div class="row-no-gutters multiselect-global-controls c-float" v-if="multiSelect">
        <div class="col-xs-6"><div class="button light d-inline-block" @click.stop="selectAll"><span class="button-text">{{ $t('select_all')}}</span></div></div>
        <div class="col-xs-6"><div class="button light d-inline-block" @click.stop="selectNone"><span class="button-text">{{ $t('unselect_all')}}</span></div></div>
      </div>
        <ul class="select-list">
          <li v-if="enableSelectNone && !multiSelect" @click.stop="selectEmpty()" class="none" style="font-weight: 500">
            {{ $t('no_selection') }}
            <input :value="$t('no_selection')" type="checkbox" style="display: none;"/>
          </li>
          <template v-if="noContinent">
                <li
                  style="padding-left: 25px"
                  @keydown.prevent="nextItem($event, option)"
                  tabIndex="-1"
                  v-for="(option, countryIndex) in filteredList"
                  :key="`option-${countryIndex}`"
                  :ref="`${randomSelectId}-${countryIndex}-opt`"
                  :class="{active : ((preselected && preselected.indexOf(option[valueKey]) > -1) || (countryIndex === indexItem))}"
                  class="flex">
                  <Checkbox
                    v-if="multiSelect && !isShortened"
                    :key="`checkbox-select-${countryIndex}`"
                    :ref="`checkbox-select-${countryIndex}`"
                    :value="preselected.indexOf(option[valueKey]) > -1"
                    class="m-r-10"
                    @click.native.stop
                    @change.native.stop="changeCountryValue(countryIndex, option)" />
                  <CountryFlag :country='option.alpha2' size='small' />
                  <span @click.stop="changeCountryValue(countryIndex, option)" style="flex: 1">
                      {{ !isShortened ? `${option.name} (${option.alpha2})` : `${option.name}` }}
                    </span>
                  <input :value="option.country_id" type="checkbox" style="display: none;"/>
                </li>
          </template>
          <template  v-for="(continent, index) in groupedList" v-else>
            <li @click.stop="toggleGroupVisibility(continent)" class="group-li" :key="`group-${index}`">
              <div class="select-group-title"> <Checkbox
                v-if="multiSelect && !isShortened"
                :key="`checkbox-group-${index}`"
                :ref="`checkbox-group-${index}`"
                class="m-r-10"
                :value="selectedContinents.includes(continent.name)"
                @change="toggleGroupValue($event, continent)" />
              {{ continent.name}} <Icon
                  class="icon"
                  :name="groupVisible(continent) ? 'arrowDown' : 'arrowRight'"
                  size="28" /></div>
                <ul class="select-sub-group" v-show="groupVisible(continent)">
                  <li
                    style="padding-left: 25px"
                    @keydown.prevent="nextItem($event, option)"
                    tabIndex="-1"
                    v-for="(option, countryIndex) in continent.items"
                    :key="`option-${index}-${countryIndex}`"
                    :ref="`${randomSelectId}-${index}-${countryIndex}-opt`"
                    :class="{active : preselected && Object.values(preselected).includes(option[valueKey])}"
                    class="flex">
                    <Checkbox
                      v-if="multiSelect && !isShortened"
                      :key="`checkbox-select-${index}-${countryIndex}`"
                      :ref="`checkbox-select-${index}-${countryIndex}`"
                      :value="preselected.indexOf(option[valueKey]) > -1"
                      class="m-r-10"
                      @click.native.stop
                      @change.native.stop="changeValue(index, countryIndex, option)" />
                    <CountryFlag :country='option.alpha2' size='small' />
                    <span @click.stop="changeValue(index, countryIndex, option)" style="flex: 1">
                      {{ !isShortened ? `${option.name} (${option.alpha2})` : `${option.name}` }}
                    </span>
                    <input :value="option.country_id" type="checkbox" style="display: none;"/>
                  </li>
                </ul>
            </li>
          </template>
        </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import CountryFlag from 'vue-country-flag';
import countryList from '@/data/country.js';
import Checkbox from '@/components/elements/inputs/checkbox';
import rules from "@/mixins/rules";
import continents from "@/data/continents";
import countryContinentMap from "@/data/countryContinentMap";
import Button from "@/components/elements/buttons/button.vue";
import i18n from "@/i18n";

export default {
  name: 'CountrySelect',
  mixins: [rules],
  components: {
    Button,
    CountryFlag, Checkbox,
  },
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    hint: {
      type: String,
      default: ''
    },
    enableSelectNone: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    preselected: {
      type: Array,
      default: () => {
        return [];
      },
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    isShortened: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: 'Choose Country',
    },
    value: {
      type: [Number, String],
      default: '',
    },
    tabIndex: {
      type: [Number],
      default: 0,
    },
    noContinent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      indexItem: 0,
      indexContinent: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
      multiSelectArray: [],
   //   selectedContinents: [],
      hiddenGroupList: [],
      showTooltip: false
    };
  },
  created() {
    if (!this.noContinent) {
      this.groupedList.forEach(group => {
        this.hiddenGroupList.push(group.name)
      })
    }
  },
  computed: {
    selectedContinents() {
      const continents = [];
      for (const continent in this.groupedList) {
        const continentArray = this.groupedList[continent].items;
        const preselectedArray = this.preselected;

        const checker = (arr, target) => target.every(v => {
          return arr.includes(v[this.valueKey])
        } );
        if (checker(preselectedArray, continentArray)) {
          continents.push(this.groupedList[continent].name)
        }
      }
      return continents
    },
    groupedList() {
      const list = [];
      const unsorted = {name: 'Other', items : []};
      for (const continentAlpha in continents) {
        const continent = { name: continents[continentAlpha], items: []};
        countryList.forEach(country => {
          if (!countryContinentMap[country.alpha2]) {
            if (!unsorted.items.find(item => item[this.valueKey] === country[this.valueKey])) {
              unsorted.items.push(country)
            }
          } else {
            if (countryContinentMap[country.alpha2] === continentAlpha) {
              continent.items.push(country);
            }
          }
        })
        continent.items = continent.items.filter(option => {
          const term = `${option.name} ${option.alpha2}`;
          return term.toLowerCase().includes(this.search.toLowerCase());
        });

        if (continent.items.length > 0) {
          list.push(continent)
        }
      }

      unsorted.items = unsorted.items.filter(option => {
        const term = `${option.name} ${option.alpha2}`;
        return term.toLowerCase().includes(this.search.toLowerCase());
      });

      if (unsorted.items.length > 0) {
        list.push(unsorted)
      }

      return list
    },
    filteredList() {
      return countryList.filter(option => {
        const term = `${option.name} ${option.alpha2}`;
        return term.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    cmpTextValue() {
      if(this.multiSelect){
        const arrayResult = [];
        countryList.forEach((item) => {
          //console.log(item[this.valueKey])
          if(this.preselected.indexOf(item[this.valueKey]) > -1){
            arrayResult.push(item.name)
          }
        });
        return arrayResult.join(', ');
      }

      if((this.value === '' || this.value === null || this.value === undefined) && this.enableSelectNone) {
        return i18n.t('no_selection')
      }

      if(this.value === null || this.value === undefined) return '';

        if( (this.value !== '') && (this.filteredList.length > 0) ) {
          this.filteredList.filter((opt, index) => {
            if(opt[this.valueKey] === this.value) this.indexItem = index;
          });
        }

        if(this.isShortened ){
          return this.value !== '' ? countryList.filter(opt => parseInt(opt[this.valueKey]) === parseInt(this.value))[0].alpha2 : '';
        } else {
          return this.value !== '' ? countryList.filter(opt => parseInt(opt[this.valueKey]) === parseInt(this.value))[0].name : '';
        }

    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
  },
  methods: {
    groupVisible(group) {
      return !this.hiddenGroupList.includes(group.name)
    },
    toggleGroupVisibility(group) {
      if(this.hiddenGroupList.includes(group.name)) {
        this.hiddenGroupList.splice(this.hiddenGroupList.indexOf(group.name), 1);
      } else {
        this.hiddenGroupList.push(group.name)
      }
    },
    selectAll() {
      if (!this.noContinent) {
        this.groupedList.forEach(group => {
          if (this.selectedContinents.indexOf(group.name) < 0) {
            this.toggleGroupValue(true, group)
          }
        })
      } else {
        this.filteredList.forEach(country => {
          this.toggleCountrySelect(true, country)
        })
      }
    },
    selectNone() {
      if (!this.noContinent) {
        this.groupedList.forEach(group => {
          this.toggleGroupValue(false, group)
        })
      } else {
        this.filteredList.forEach(country => {
          this.toggleCountrySelect(false, country)
        })
      }
    },
    toggleGroupValue(value, continent) {
      let index = this.selectedContinents.indexOf(continent.name);

      if (value) {
        if (index < 0) {
          this.selectedContinents.push(continent.name);
        }
      } else {
        if (index >= 0) {
          this.selectedContinents.splice(index, 1);
        }
      }
      continent.items.forEach(country => {
        this.toggleCountrySelect(value, country)
      })
    },
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.nextItem(event);
      } else {
        this.indexItem = 0;
        this.search = event.target.value;
      }
    },
    nextItem (event, option) {
      if(event.keyCode == 9) this.closeSelect();

      if (!this.noContinent) {
        if (event.keyCode == 38 && this.indexItem > 0) {
          this.indexItem--;
          this.$refs[`${this.randomSelectId}-${this.indexContinent}-${this.indexItem}-opt`][0].focus();
        } else if (event.keyCode == 40 && this.indexItem < this.groupedList[this.indexContinent].items.length - 1) {
          this.indexItem++;
          this.$refs[`${this.randomSelectId}-${this.indexContinent}-${this.indexItem}-opt`][0].focus();
        } else if (event.keyCode == 13) {
          this.$refs[`${this.randomSelectId}-${this.indexContinent}-${this.indexItem}-opt`][0].click();
        }
      } else {
        if (event.keyCode == 38 && this.indexItem > 0) {
          this.indexItem--;
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        } else if (event.keyCode == 40 && this.indexItem < this.groupedList[this.indexContinent].items.length - 1) {
          this.indexItem++;
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        } else if (event.keyCode == 13) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
          this.changeCountryValue(this.indexItem, option)
        }
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    changeValue(continentIndex, index, option) {
      if(!this.multiSelect){
        this.indexItem = index;
        this.indexContinent = continentIndex;
        this.isListOpened = false;
        this.openedOnClick = false;
        this.$emit('change', option[this.valueKey]);
        this.$emit('input', option[this.valueKey]);
        this.search = '';
      } else {
        this.toggleCountrySelect(!this.$refs[`checkbox-select-${continentIndex}-${index}`][0].value, option)
      }
    },
    changeCountryValue(index, option) {
      if(!this.multiSelect){
        this.indexItem = index;
        this.isListOpened = false;
        this.openedOnClick = false;
        this.$emit('change', option[this.valueKey]);
        this.$emit('input', option[this.valueKey]);
        this.search = '';
      } else {
        this.isListOpened = true;
        this.toggleCountrySelect(!this.$refs[`checkbox-select-${index}`][0].value, option)
      }
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    openListOnClick() {
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        if(!this.noContinent && this.groupedList[0] && this.groupedList[0].items.length > 0 && this.$refs[`${this.randomSelectId}-${this.indexContinent}-${this.indexItem}-opt`][0]) {
          this.$refs[`${this.randomSelectId}-${this.indexContinent}-${this.indexItem}-opt`][0].focus();
        }
        if (this.noContinent && this.countryList && this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0]) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
    openListOnFocus() {
      this.isListOpened = true;
      this.$nextTick(() => {
        if(!this.noContinent && this.groupedList[0] && this.groupedList[0].items.length > 0 &&  this.$refs[`${this.randomSelectId}-${this.indexContinent}-${this.indexItem}-opt`][0]) {
          this.$refs[`${this.randomSelectId}-${this.indexContinent}-${this.indexItem}-opt`][0].focus();
        }
        if (this.noContinent && this.countryList && this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0]) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
    selectEmpty() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.$emit('change', '');
      this.$emit('input', '');
      this.search = '';
    },
    toggleCountrySelect(val, item) {
      console.log(val, item)
      const newArray = this.preselected;
      console.log(val, item)
      if (!val) {

        if (newArray.indexOf(item[this.valueKey]) > -1) {
          newArray.splice(newArray.indexOf(item[this.valueKey]), 1);
        }
      } else {
        if (newArray.indexOf(item[this.valueKey]) < 0) {
          newArray.push(item[this.valueKey]);
        }
      }

      this.$emit('change', newArray);
      this.$emit('input', newArray);
    },
  },
}
</script>
